<template>
    <div class="prompt-check-alternatives">

        <div class="prompt-check-alternatives__header">
            <svg>
                <circle id="Oval" fill="#D52727" fill-rule="evenodd" cx="13.5" cy="13.5" r="13.5"></circle>
                <path d="M17.5,9.5 L9.01471863,17.9852814" id="Line-4" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round"></path>
                <path d="M17.5,9.5 L9.01471863,17.9852814" id="Line-4" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" transform="translate(13.257359, 13.742641) scale(-1, 1) translate(-13.257359, -13.742641) "></path>
            </svg>

            <strong>{{ title }}</strong>
        </div>

        <p v-if="message">
            {{ message }}
        </p>

        <div class="prompt-check-alternatives__buttons">
            <button v-if="shouldShowCloseButton" v-on:click="close()" class="button">{{ closeButtonText }}</button>
            <button v-if="shouldShowActionButton" class="button" v-on:click="action">{{ buttonText }}</button>
            <button v-if="shouldShowTertiaryButton" class="button" v-on:click="tertiaryAction">{{ tertiaryButtonText }}</button>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'popup',
    props: [
      'title',
      'message',
      'buttonText',
      'closeButtonText',
      'tertiaryButtonText'
    ],
    methods: {
      close () {
        this.$root.prompt.isOpen = false

        // Wait till the next tick so that the popup closes fully.
        this.$nextTick(() => {
          this.$emit('close', this.$root.prompt.closeButtonMethod)
        })
      },
      action () {
        this.$emit('action', this.$root.prompt.actionButtonMethod)
      },
      tertiaryAction () {
        this.$emit('tertiaryAction', this.$root.prompt.tertiaryButtonAction)
      }
    },
    computed: {
      shouldShowCloseButton: function () {
        return this.$root.prompt.shouldShowCloseButton
      },
      shouldShowActionButton: function () {
        return this.$root.prompt.shouldShowActionButton
      },
      shouldShowTertiaryButton: function () {
        return this.$root.prompt.shouldShowTertiaryButton
      }
    }
  }
</script>



// WEBPACK FOOTER //
// popup.vue?34c3bc91